// extracted by mini-css-extract-plugin
export var container__title = "FeaturedCard-module--container__title--20c4c";
export var img = "FeaturedCard-module--img--5b4ac";
export var imgBase = "FeaturedCard-module--imgBase--8f8de";
export var imgHovered = "FeaturedCard-module--imgHovered--f5203";
export var imgNotHovered = "FeaturedCard-module--imgNotHovered--8833c";
export var img__container = "FeaturedCard-module--img__container--329cf";